// frontend/src/components/FinanceReport/Accounting/components/accounts/company-accounts/AccountFormModal.jsx

import { useEffect, useState } from "react";
import { createAccount, updateAccount } from "./requests";

const CURRENCY_OPTIONS = ["USD", "RUB", "CNY", "USDT", "TRX"];

const emptyForm = () => ({ name: "", currency: "USD", comment: "" });

export default function AccountFormModal({
  open,
  mode,
  initial,
  onClose,
  onSaved,
}) {
  const [form, setForm] = useState(emptyForm());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    if (mode === "edit" && initial) {
      setForm({
        name: initial.name || "",
        currency: initial.currency || "USD",
        comment: initial.comment || "",
      });
    } else {
      setForm(emptyForm());
    }
  }, [open, mode, initial]);

  if (!open) return null;

  const setField = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.name.trim()) {
      setError("Введите название счёта.");
      return;
    }

    setSaving(true);
    try {
      const payload = {
        name: form.name.trim(),
        currency: form.currency,
        comment: form.comment || "",
      };

      let saved;
      if (mode === "edit" && initial) {
        saved = await updateAccount(initial.id, payload);
      } else {
        saved = await createAccount(payload);
      }

      await onSaved(saved);
    } catch (err) {
      setError(err.message || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !saving) onClose();
      }}
    >
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl"
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">
            {mode === "edit" && initial ? "Редактировать счёт" : "Новый счёт"}
          </h2>
          <button
            type="button"
            onClick={() => !saving && onClose()}
            className="rounded-lg px-2 py-1 text-slate-500 hover:bg-slate-100"
          >
            ✕
          </button>
        </div>

        {error && (
          <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <input
            className="w-full border p-2 rounded-xl"
            placeholder="Название"
            value={form.name}
            onChange={(e) => setField("name", e.target.value)}
            required
          />

          <select
            className="w-full border p-2 rounded-xl"
            value={form.currency}
            onChange={(e) => setField("currency", e.target.value)}
          >
            {CURRENCY_OPTIONS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <input
            className="w-full border p-2 rounded-xl"
            placeholder="Комментарий"
            value={form.comment}
            onChange={(e) => setField("comment", e.target.value)}
          />

          <button
            type="submit"
            disabled={saving}
            className="w-full bg-black text-white py-2 rounded-full disabled:opacity-50"
          >
            {saving
              ? "Сохранение…"
              : mode === "edit"
              ? "Сохранить"
              : "Создать"}
          </button>
        </div>
      </form>
    </div>
  );
}